import {addEventToEvents} from '@/redux-store/slices/events';
import {store} from '@/redux-store/store';
import keycloakAxios from '@/services/axios';
import {EventData, EventFormData} from '@/types/event';
import {emitEventChangeEvent} from './change-observable';

export const addEvent = async (eventObject: EventFormData) => {
  const response = await keycloakAxios.post('event/', eventObject);

  if (response.status >= 300) {
    throw new Error(
      `Error adding event: Invalid status code: ${response.status}`
    );
  }

  emitEventChangeEvent({
    type: 'new',
    data: response.data as EventData
  });

  store.dispatch(addEventToEvents({event: response.data}));

  return response.data;
};
